//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingStar(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M22.4902 10.26L21.8402 8.27998L15.7602 7.38998L13.0902 1.97998H10.9102L8.24021 7.38998L2.16021 8.27998L1.47021 10.4L9.57021 9.21998L12.0002 4.28998L14.4302 9.21998L19.8802 10.01L15.9402 13.85L16.8702 19.27L12.0002 16.71L7.13021 19.27L8.06021 13.85L5.92021 11.77L3.43021 12.13L5.91021 14.55L4.84021 20.78L6.40022 21.91L12.0002 18.97L17.6002 21.91L19.1602 20.78L18.0902 14.55L22.4902 10.26Z" fill="currentColor" /></svg>;
}
export default IconRatingStar;